import {
  BannerDefault,
  registerClick,
} from 'src/services/marketplace-api/banner'
import CarrosselPrincipal, { paramsSliderCarrousel } from '.'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import GImage from '../gImage'
import { useBreakpointValue } from '@gazin/ecommerce-ui'
import { useCallback, useEffect, useState } from 'react'

export type DefaultCarouselProps = {
  banners: BannerDefault[]
  swiperColor?: string
  darkTheme?: boolean
  isCategory?: boolean
}

type BannerComponent = {
  urlImage: string
  banner: BannerDefault
}

export const DefaultCarousel = ({
  banners,
  darkTheme,
  swiperColor,
  isCategory,
}: DefaultCarouselProps) => {
  const [slides, setSlides] = useState<BannerComponent[]>([])

  const isMobile = Boolean(
    useBreakpointValue({ base: true, sm: true, md: false })
  )
  const registrarClick = async (e: any) => {
    e.preventDefault()
    const targetDOM = e.currentTarget
    const bannerId = targetDOM.dataset.id

    await registerClick(bannerId)

    if (targetDOM.target === '_self') {
      window.location.href = targetDOM.href
    } else {
      window.open(targetDOM.href, targetDOM.target)
    }
  }

  const validaBanner = useCallback(() => {
    setSlides(
      banners.reduce((slidesValidos: BannerComponent[], banner) => {
        const tempArray: BannerComponent[] = []

        if (isMobile) {
          if (banner.banner.imagem_mobile) {
            tempArray.push({
              banner: banner,
              urlImage: banner.banner.imagem_mobile.url,
            })
          }
        } else {
          if (banner.banner.imagem_desktop) {
            tempArray.push({
              banner: banner,
              urlImage: banner.banner.imagem_desktop.url,
            })
          }
        }

        return slidesValidos.concat(tempArray)
      }, [])
    )
  }, [isMobile, banners])

  useEffect(() => {
    validaBanner()
  }, [isMobile, validaBanner])

  const renderSlideDefault = (banner: BannerComponent, key: number) => {
    if (banner?.banner?.banner.link?.tipo_chave === 'link-url') {
      return (
        <SwiperSlide key={key}>
          <Link
            href={
              banner.banner.banner.link.parametros?.url
                ? banner.banner.banner.link.parametros.url
                : '#'
            }
            prefetch={false}
            onClick={(e) => registrarClick(e)}
            data-id={banner.banner.banner.id}
            target={
              banner.banner.banner.link.parametros
                ? banner.banner.banner.link.parametros.target
                : '_self'
            }
          >
            <GImage
              src={banner.urlImage}
              fill
              sizes="100vw"
              quality={99}
              priority={key === 0 ? true : false}
              alt={banner.banner.banner.titulo}
              style={{ objectFit: 'cover' }}
            />
          </Link>
        </SwiperSlide>
      )
    } else {
      return (
        <SwiperSlide>
          <Link href="/categoria" as="/categoria">
            <GImage
              src={banner.urlImage}
              fill
              quality={99}
              alt="Banner Categoria"
              style={{ objectFit: 'cover' }}
            />
          </Link>
        </SwiperSlide>
      )
    }
  }

  return (
    <>
      {!!slides.length && (
        <CarrosselPrincipal
          darkTheme={darkTheme}
          swiperColor={swiperColor}
          isCategory={isCategory}
        >
          <Swiper {...paramsSliderCarrousel}>
            {slides.map((banner, key) => {
              return renderSlideDefault(banner, key)
            })}
          </Swiper>
        </CarrosselPrincipal>
      )}
    </>
  )
}
